import api from '../lib/api'

export const FETCH_ME = 'controller-tool/me/fetch-me'
export const SET_ME = 'controller-tool/me/set-me'

export default function reducer(state = null, action = {}) {
  switch (action.type) {
    case FETCH_ME:
      return 'fetching'
      break

    case SET_ME:
      return {...action.me}
      break

    default:
      return state
      break
  }
}

export function fetchMe(token) {
  return (dispatch) => {
    api
    .me(token)
    .then(user => {
      dispatch(setMe(user))
    })
    .catch(err => {
      console.error(`[fetchMe] error fetching user: ${err.message}`)
    })
  }
}

export function setMe(user) {
  return { type: SET_ME, me: user }
}



// WEBPACK FOOTER //
// ./ducks/me.js